const configTopic = {
  topic: {
    listLayout: "TopicListDefaultLayout",
    filterLayout: "TopicFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getTopic",
    listApiParamSet: {
      ip: 1,
      sp: 10,
      page: 1,
      ty: "subject",
    },
    isCategory: true,
    getCategoryFunc: "getCategory",
    categoryApiParamsSet: {
      ip: 0,
      ty: "subject",
    },
  },
  topicCreate: {
    getCategoryFunc: "getCategory",
    categoryApiParamsSet: {
      ip: 0,
      ty: "subject",
    },
    isCategory: true,
    writeLayouts: ["TopicWriteDefaultLayout"],
    writeFunc: "createTopic",
    writeApiParamSet: {
      oc_type: 'subject',
    },
    keyName: "oc_idx",
    parsingData: {
      eng: "ot_eng",
      kor: "ot_kor",
      cn: "ot_cn",
      display: "ot_display",
      level: "ot_level",
      category: "oc_idx",
    },
    fileInfo: [
      {
          fileName: 'files',
          fileType: 'topic',
      },
      {
          fileName: 'cardFile',
          fileType: 'card',
      },
  ],
    writeSuccessType: 1,
    writeFailTypes: {
      "-403": "권한이 없습니다.",
      "-100": "필수값이 없습니다.",
      "-101": "유효성 실패입니다.",
      "-103": "선택하신 카테고리는 삭제된 카테고리입니다.",
    },
    getDetailParamsKey: "",
    directType: "back",
    directUrl: "",
  },
  topicUpdate: {
    getFunc: "getTopic",
    detailApiParamsSet: {
      opt: 1,
      ip: 0,
    },
    getDetailParamsKey: "id",
    getCategoryFunc: "getCategory",
    categoryApiParamsSet: {
      ip: 0,
      ty: "subject",
    },
    isCategory: true,
    writeLayouts: ["TopicWriteDefaultLayout"],
    writeFunc: "updateTopic",
    writeApiParamSet: {},
    keyName: "ot_idx",
    parsingData: {
      eng: "ot_eng",
      kor: "ot_kor",
      cn: "ot_cn",
      display: "ot_display",
      level: "ot_level",
      category: "oc_idx",
    },
    fileInfo: [
      {
          fileName: 'files',
          fileType: 'topic',
      },
      {
          fileName: 'cardFile',
          fileType: 'card',
      },
    ],
    writeSuccessType: 1,
    writeFailTypes: {
      "-403": "권한이 없습니다.",
      "-100": "필수값이 없습니다.",
      "-101": "유효성 실패입니다.",
      "-103": "선택하신 카테고리는 삭제된 주제입니다.",
      "-404": "존재하지 않는 토픽입니다.",
    },
    directType: "back",
    directUrl: "",
    deleteFunc: "deleteTopic",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {
      "-403": "권한이 없습니다.",
      "-100": "필수값이 없습니다.",
      "-101": "유효성 실패입니다.",
      "-103": "선택하신 카테고리는 삭제된 주제입니다.",
    },
  },

  expression: {
    listLayout: "TopicListLevelLayout",
    filterLayout: "TopicFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getTopic",
    listApiParamSet: {
      ip: 1,
      sp: 10,
      page: 1,
      ty: "expression",
    },
    isCategory: true,
    getCategoryFunc: "getCategory",
    categoryApiParamsSet: {
      ip: 0,
      ty: "expression",
    },
  },
  expressionCreate: {
    getCategoryFunc: "getCategory",
    categoryApiParamsSet: {
      ip: 0,
      ty: "expression",
    },
    isCategory: true,
    writeLayouts: ["TopicWriteDefaultLayout"],
    writeFunc: "createTopic",
    writeApiParamSet: {},
    keyName: "oc_idx",
    parsingData: {
      eng: "ot_eng",
      kor: "ot_kor",
      cn: "ot_cn",
      display: "ot_display",
      level: "ot_level",
      category: "oc_idx",
    },
    fileInfo: [
      {
          fileName: 'files',
          fileType: 'topic',
      },
      {
          fileName: 'cardFile',
          fileType: 'card',
      },
    ],
    writeSuccessType: 1,
    writeFailTypes: {
      "-403": "권한이 없습니다.",
      "-100": "필수값이 없습니다.",
      "-101": "유효성 실패입니다.",
      "-103": "선택하신 카테고리는 삭제된 카테고리입니다.",
    },
    getDetailParamsKey: "",
    directType: "back",
    directUrl: "",
  },
  expressionUpdate: {
    getFunc: "getTopic",
    detailApiParamsSet: {
      opt: 1,
      ip: 0,
    },
    getDetailParamsKey: "id",
    getCategoryFunc: "getCategory",
    categoryApiParamsSet: {
      ip: 0,
      ty: "expression",
    },
    isCategory: true,
    writeLayouts: ["TopicWriteDefaultLayout"],
    writeFunc: "updateTopic",
    writeApiParamSet: {
      oc_type: "expression",
    },
    keyName: "ot_idx",
    parsingData: {
      eng: "ot_eng",
      kor: "ot_kor",
      cn: "ot_cn",
      display: "ot_display",
      level: "ot_level",
      category: "oc_idx",
    },
    fileInfo: [
      {
          fileName: 'files',
          fileType: 'topic',
      },
      {
          fileName: 'cardFile',
          fileType: 'card',
      },
    ],
    writeSuccessType: 1,
    writeFailTypes: {
      "-403": "권한이 없습니다.",
      "-100": "필수값이 없습니다.",
      "-101": "유효성 실패입니다.",
      "-103": "선택하신 카테고리는 삭제된 주제입니다.",
      "-404": "존재하지 않는 토픽입니다.",
    },
    directType: "back",
    directUrl: "",
    deleteFunc: "deleteTopic",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {
      "-403": "권한이 없습니다.",
      "-100": "필수값이 없습니다.",
      "-101": "유효성 실패입니다.",
      "-103": "선택하신 카테고리는 삭제된 주제입니다.",
    },
  },
};

export default {
    methods: {
        returnTopicConfig(type) {
            return configTopic[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        lv : { // 난이도
            type: 'match',
            classname: 'filterLevel',
        },
        di : { // 노출 유무
            type: 'match',
            classname: 'filterDisplay',
        },
        eng: { // 영어
            type: 'query',
            classname: 'searchInput'
        },
        kor: { // 한국어
            type: 'query',
            classname: 'searchInput'
        },
        cn: { // 중국어
            type: 'query',
            classname: 'searchInput'
        },
        cid : {
            type: 'match',
            classname: 'filterCategory',
        },
    }
}
